
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/signup",
      function () {
        return require("private-next-pages/member/signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member/signup"])
      });
    }
  